<style scoped>
.navbar-sshi {
  background-color: #f7f1e3 !important;
}

.navbar-light .navbar-nav .nav-link {
  color: #218c74 !important;
}

.navbar-light .navbar-nav .nav-link.active {
  background-color: #218c74;
  color: #218c74 !important;
  border-bottom-left-radius: 0.75rem !important;
  border-bottom-right-radius: 0.75rem !important;
  border: none;
}

</style>
<template>
  <div>
    <b-navbar toggleable="lg" type="light" class="navbar-sshi fixed-top navbar-primary">
      <b-container fluid>
        <b-navbar-brand to="/"
          ><b-img
            src="/img/logo-text.svg"
            fluid
            alt="Responsive image"
            class="indah-brand"
          ></b-img
        ></b-navbar-brand>
        <b-navbar-brand to="/sshi2023"
          ><b-img
            src="/img/application/psdk.svg"
            fluid
            alt="Responsive image"
            class="indah-brand"
            style="margin-left: -1.25rem; background: #fff; border-radius: 50%"
          ></b-img
        ></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse" class="mr-2 text-white" style="background: #218c74;">
          <template #default="{ expanded }">
            <b-icon v-if="expanded" icon="x"></b-icon>
            <b-icon v-else icon="list"></b-icon>
          </template>
        </b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/sshi2023/beranda">Beranda</b-nav-item>
            <b-nav-item to="/sshi2023/daftar-keluarga">Daftar Keluarga</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav
            v-if="this.$store.getters['auth/isAuthenticated']"
            class="ml-auto"
          >
            <b-dropdown
              right
              size="sm"
              variant="sshi2023"
              :text="$store.getters['auth/user'].name"
            >
              <b-dropdown-item to="/profile">Profil</b-dropdown-item>
              <b-dropdown-item to="/profile/change-password"
                >Ubah Password</b-dropdown-item
              >
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/logout">Keluar</b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>

          <b-navbar-nav v-else class="ml-auto">
            <b-button
              variant="login"
              size="sm"
              type="submit"
              to="/login"
              class="btn-login"
              >Masuk</b-button
            >
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
export default {
  name: "navbar-sshi2023",
  data() {
    return {
    };
  },
  components: {
  },
  created() {},
  methods: {
  },
};
</script>
